import React, { useRef, useEffect, useState } from 'react';
import CreateCloudfrontUrl from '/src/services/CreateCloudfrontUrl';
import DatapointInput from '../DatapointInput/DatapointInput';
import './style.css';

const InputsDisplay = ({
    selectedData,
    projects,
    inputsType,
    handleDatapointChange,
    handleMarkProjectCompleted
}) => {


    return (
        <>
            {inputsType === "regular" && (
                <div className="datapoints-container">
                    {selectedData.map(datapoint => (
                        <DatapointInput
                            key={datapoint.id}
                            datapoint={datapoint}
                            onChange={(value) => handleDatapointChange(datapoint.id, value)}
                        />
                    ))}
                </div>
            )}
            {inputsType === "projects" && (
                <div className="resilience-grid">
                    {projects.map(project => (
                        <div key={project.project_id} className="form-project-card">
                            <div className="project-image-container">
                                <img
                                    src={CreateCloudfrontUrl(project.project_image)}
                                    alt={project.project_name}
                                    className="form-project-image"
                                />
                            </div>
                            <div className="form-project-card-details">

                                <h3 className="update-module-project-name text-align-center">{project.project_name}</h3>
                                <button className="mark-completed-button box-shadow-standard" onClick={() => handleMarkProjectCompleted(project)}>
                                    Mark Completed
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </>
    );
};

export default InputsDisplay;